import { render, staticRenderFns } from "./StoreLoader.vue?vue&type=template&id=56d6e910&scoped=true"
import script from "./StoreLoader.vue?vue&type=script&lang=js"
export * from "./StoreLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d6e910",
  null
  
)

export default component.exports